/**
 * Phase F-finale-5 Slice 5a — single source of truth for the IA forms
 * editor route.
 *
 * The list page links to the editor and `App.tsx` registers the route.
 * Keeping the path in two hand-written string literals let them drift:
 * the list linked to `/forms/:slug/edit` while the route was declared as
 * `/forms/:slug`, so every form link bounced to the dashboard catch-all.
 * Both sides now derive from this module, so a mismatch is impossible
 * (the `:formSlug` param name also stays in lockstep with the editor's
 * `useParams<{ formSlug: string }>()`).
 */

/** React Router pattern for the editor route. Used in `App.tsx`. */
export const FORM_EDITOR_ROUTE_PATTERN = "/forms/:formSlug/edit";

/** Concrete editor path for a given form slug. Used by list links. */
export function formEditorPath(slug: string): string {
  return `/forms/${slug}/edit`;
}
